module.exports = __webpack_public_path__ + "static/media/ericSchwartz.572d5e10.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/authorSpotlight/ericSchwartz.jpg
// module id = 1671
// module chunks = 1